import type { BaseTranslation } from "../i18n-types"

const es: BaseTranslation = {
  HI: "Hola",
  bracelets: {
    addMore: "Añadir más",
    copyClipboard: "Copiado al portapapeles",
    copyCTA: "Copiar enlace",
    copyDescription:
      "Copie el enlace a continuación para compartir su collar de amuleto con amigos y familiares.",
    done: "Hecho",
    introHeadline: "Seleccione sus brazaletes",
    introDescription:
      "Elija sus estilos, metales y piedras preciosas favoritos para añadir. Una vez que haya hecho su selección, toque o haga clic en un diseño para moverlo hacia arriba o hacia abajo en su pila. Si desea eliminar una pulsera, toque o haga clic en la X junto a ella.",
    help: "Necesita ayuda?",
    limitHeadline: "Limite Alcanzado",
    limitDescription:
      "No puedes añadir más brazaletes. Por favor elimina un brazalete para añadir este diseño",
    modify: "Modificar",
    moreInfo: "Click para más información",
    nextStep: "Siguiente",
    quickView: "Vista Rápida",
    rearrange: "Ordenar",
    previewSelection: "Previsualiza tu selección",
    reviewSelection: "Revisa tu selección",
    reviewStack: "Revisa tus articulos",
    selected: "Seleccionado",
    share: "Compartir",
    shareThis: "Compartir",
    viewDetails: "Ver Detalles.",
  },
  amulets: {
    amuletGridHeadline: "AMULETOS SELECCIONADOS ({0} A {1}) ",
    changeChain: "Cambiar Cadena",
    chooseHeadline: "Escoge tu Cadena",
    chooseChain: "Escoge una Cadena",
    copyClipboard: "Copiado al portapapeles",
    copyCTA: "Copiar enlace",
    copyDescription:
      "Copie el enlace a continuación para compartir su collar de amuleto con amigos y familiares.",
    done: "Hecho",
    expand: "Expandir",
    introHeadline: "Agregar Amuletos",
    introDescription:
      "Arrastra y suelta tus diseños favoritos para verlos en tu cadena.",
    help: "Necesita ayuda?",
    limit: "Limite alcanzado",
    limitDescription:
      "No puedes añadir más amuletos. Por favor eliminar un amuleto para añadir este diseño.",
    moreInfo: "Click para más información",
    nextStep: "Siguiente",
    modify: "Modificar",
    previewNecklace: "Vista previa del collar",
    rearrange: "Ordenar",
    reviewSelection: "Revisa tu selección",
    selected: "Seleccionado",
    share: "Compartir",
    shareThis: "Compartir",
  },
}

export default es
